import { render, staticRenderFns } from "./supportTicketNew.vue?vue&type=template&id=9b4acb04&"
import script from "./supportTicketNew.vue?vue&type=script&lang=js&"
export * from "./supportTicketNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports